import rangesliderJs from 'rangeslider-js'
import loadSvg from '../utils/svg'

(function( $ ) {

  if ($('form.calculator-fields').length > 0) {

    $('.calculator-icon .round-icon').addClass('active')

    const slider = document.getElementById("range-slider");

    const resultPage = $('form.calculator-fields').data('result');
  
    const startSurface = $('#surface').val();

    rangesliderJs.create(slider, {
      min: 70,
      max: 400,
      value: startSurface,
      onInit: (value, percent, position) => {
        $('.surface').val(value)
      },
      onSlide: (value, percent, position) => {
        $('.surface').val(value)
      }
    });
    
    $('.surface').on('keypress',function (e){ 
      var charCode = (e.which) ? e.which : e.keyCode;
      console.log(charCode)
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
      }
    }); 
    
    $('.surface').on('paste',function (e){ 
      let surface = $('.surface').val();
      surface = surface.replace(/\D/g,'');

      $('.surface').val(surface);
    }); 
  
    $('.surface').on('change keyup',function (e){ 
      let surface = $('.surface').val();
      if (surface > 400) {
        surface = 400
        $('.surface').val(surface);
      }
      $('.range').val(surface).change();
      const sliderJS = slider["rangeslider-js"];
      sliderJS.update({ value: surface });
    }); 
      
    $('img.svg').each(function() {
      loadSvg(this)
    });     
  
    $('form.calculator-fields .elementor-field').keydown(function(){     
      if( (event.keyCode == 13) ) {
        $('form.calculator-fields .error-field').show();
      }
    });
  
    $('form.calculator-fields button[type="submit"]').click(function(){
      $('form.calculator-fields .error-field.fields').show();
    });
  
    $('form.calculator-fields').submit(function(e){
      $('form.calculator-fields .error-field.fields').hide();
      $('form.calculator-fields .error-field.form').hide();

      let nonce = $('form.calculator-fields .nonce').val();
      //let phone = $('form.calculator-fields .phone').val();
  
      let surface = $('form.calculator-fields .surface').val();
      let house_type = $('form.calculator-fields .house_type:checked').val();
      let roof_type = $('form.calculator-fields .roof_type:checked').val();
      let time = $('form.calculator-fields .time:checked').val();
      let region = ($('form.calculator-fields .region').length > 0) ? $('form.calculator-fields .region').val() : false;
      let name = ($('form.calculator-fields .name').length > 0) ? $('form.calculator-fields .name').val() : false;
      let email = ($('form.calculator-fields .name').length > 0) ? $('form.calculator-fields .email').val() : false;
      let phone = ($('form.calculator-fields .prefix-phone').length > 0) ? $('form.calculator-fields .prefix-phone').val().replaceAll(' ', '') : false;
      
      let house_type_name = $('form.calculator-fields .house_type:checked').parent().find('label').text();
      let roof_type_name = $('form.calculator-fields .roof_type:checked').parent().find('label').text();
  
      $('.calculator-result .surface').text(surface);
      $('.calculator-result .house_type').text( house_type_name );
      $('.calculator-result .roof_type').text( roof_type_name );
      $('.inputs img').hide();
      $('.inputs img.'+ house_type +'-'+ roof_type).show();
  
      //console.log(phone);
      $('form.calculator-fields .elementor-button').prop('disabled', true);
      $('form.calculator-fields .elementor-button i').addClass('show');
  
      $.ajax({
        type: 'POST',
        url: ajax.ajax.url,
        dataType: 'json',
        data: {
          action: 'generate_verification_code',
          nonce: nonce,
          surface: surface,
          house_type: house_type,
          house_type_name: house_type_name,
          roof_type: roof_type,
          roof_type_name: roof_type_name,
          time: time,
          region: region,
          phone: phone,
          email: email,
          name: name,
        },
        success: function(result) {
          if(result.success == true) {
            if (result.hasOwnProperty('code')) {
              $('.verification-code').val('');
              $('.verify-phone').fadeIn();
            } else {
              //console.log(result)
              window.location.href = resultPage;
              //$('.verify-phone').fadeIn();
            }
          }
        },
        error: function(errorThrown){
          console.log(errorThrown);
          $('form.calculator-fields .error-field.form').show();
        },
        complete: function() {
          $('form.calculator-fields .elementor-button').prop('disabled', false);
          $('form.calculator-fields .elementor-button i').removeClass('show');
          
          $('.verify-phone .send-again').removeClass('disabled');
          $('.verify-phone .send-again i').removeClass('show');
        }
      });
  
      e.preventDefault();
    })
  
    $('.verification-code').focus(function(){
      let previousInput = $(this).prev('.verification-code')
      let value = previousInput.val();
      if (value == '' && previousInput.length > 0) {
        previousInput.focus();
      }
    });
  
    $('.verification-code').keydown(function(event){
      if( (event.keyCode == 13) ) {
        event.preventDefault();
        return false;
      }
    });

    $('.verification-code').on('paste', function () {
      let element = this;
      setTimeout(function () {
        let code = $(element).val();
        // do something with text
        let index = 0;
        $('.verification-code').each(function(){
          let codePart = code.slice(index, index+1);
          $(this).val(codePart);
          index++;
        });
      }, 10);
    });
  
    $('.verification-code').keyup(function(event){
      let value = $(this).val();
      let nextInput = $(this).next('.verification-code')
      if($.isNumeric(value)) {
        if(nextInput.length > 0) {
          nextInput.focus();
        } else {
          $('form.code-verification-form').submit();
        }
      } else {
        $(this).val('')
      }
    });
  
    $('.send-again').click(function(e){
      $('.verification-code').val('')

      let nonce = $('form.code-verification-form .nonce').val();
      
      $('.verify-phone .send-again').addClass('disabled');
      $('.verify-phone .send-again i').addClass('show');

      $('form.calculator-fields').submit();

      e.preventDefault();
    });   
  
    $('form.code-verification-form').submit(function(e){
      let nonce = $('form.code-verification-form .nonce').val();
      let code = $('form.code-verification-form #verification-code-1').val() + $('form.code-verification-form #verification-code-2').val()+ $('form.code-verification-form #verification-code-3').val() + $('form.code-verification-form #verification-code-4').val()+ $('form.code-verification-form #verification-code-5').val();

      $('.loader').show();
      
      //console.log(phone); 
      // $('form.calculator-fields .code-verification-form').prop('disabled', true);
      // $('form.code-verification-form .elementor-button i').addClass('show');
  
      $('form.code-verification-form .error-field').hide();
  
      $.ajax({
        type: 'POST',
        url: ajax.ajax.url,
        dataType: 'json',
        data: {
          action: 'check_verification_code',
          nonce: nonce,
          code: code,
        },
        success: function(result) {
          console.log(result)
          if(result.success == true) {          
            window.location.replace(resultPage);
          } else {
            $('form.code-verification-form .error-field').show();
          }
        },
        error: function(errorThrown){
          console.log(errorThrown);
        },
        complete: function() {
          $('.loader').hide();
          // $('form.calculator-fields .code-verification-form').prop('disabled', false);
          // $('form.code-verification-form .elementor-button i').removeClass('show');
        }
      });
  
      e.preventDefault();
    })
  
    $('.verify-phone .overlay').click(function(){
      $('.verify-phone').fadeOut();
    })
  }

})(jQuery);


// WEBPACK FOOTER //
// ./resources/assets/js/partials/calculator.js